{
    "account": "Account",
    "add_bookmark": "Bookmark message",
    "add_date": "Add a date",
    "ago": "{{duration}} ago",
    "and_x_more": "and {{count}} more",
    "api_key": "API key",
    "are_you_sure": "Are you sure?",
    "ask_delete_message": "Delete this message?",
    "audio_not_ready": "Audio is not ready yet.",
    "bookmark_added": "Message bookmarked.",
    "bookmark_removed": "Message bookmark removed.",
    "bookmarks": "bookmarks",
    "cancel": "Cancel",
    "cancel_write": "Do you really want to cancel writing a new message?",
    "changed_group_name": "changed the group's name",
    "confirm_password_placeholder": "confirm password",
    "connect": "Connect",
    "create_a_group": "Create a group",
    "create_the_group": "Create the group",
    "daily": "Daily",
    "default_group": "Default group",
    "default_page": "Default page",
    "delete": "Delete",
    "destroy_account": "Delete your account",
    "destroy_account_explain": "Once you delete your account, there is no going back. Please be certain.",
    "edit": "Edit",
    "email_disabled": "Emails are disabled. Please contact your system administrator to reset your password.",
    "email": "E-mail",
    "email_input": "Fill in your e-mail address here",
    "empty_message": "The message is empty and cannot be sent.",
    "error": "An error occurred",
    "error_new_message": "An error occurred while sending your message.",
    "error_upload": "An error occurred during the upload",
    "feed": "Feed",
    "feed_group": "My Feed",
    "forgot_password": "Forgot your password?",
    "group_left": "You left the group.",
    "groups": "Groups",
    "group_share_choice": "Which group do you want to send this message to?",
    "group_updated": "The group was updated.",
    "has_commented_on": "has commented on",
    "has_joined": "has joined",
    "has_left": "has left",
    "has_posted_in": "has posted in",
    "hourly": "Hourly",
    "immediately": "Immediately",
    "in": "in",
    "Invalid login/password": "Invalid login and/or password",
    "invalid_token_error": "This link is no longer valid.",
    "invitation_link": "Invitation link",
    "invitation_welcome": "Welcome to Zusam. Please sign up before joining the group.",
    "just_now": "Just now",
    "lang": "language",
    "login_input": "Choose a login",
    "login": "Log in",
    "login_placeholder": "e-mail",
    "logout": "Log out",
    "mark_all_as_read": "mark all as read",
    "monthly": "Monthly",
    "multiple_photos_upload": "An error ocurred. Try uploading images one by one (this can happen in some browsers)",
    "name_input": "Choose a name",
    "name": "Name",
    "new_password_placeholder": "new password",
    "next_coms": "See next comments",
    "none": "None",
    "notification_emails": "E-mail notifications",
    "notification_emails_stopped": "E-mail notifications stopped!",
    "notifications": "notifications",
    "parent_message": "Parent message",
    "password_input": "Write a new password here",
    "password": "Password",
    "password_placeholder": "password",
    "password_reset_mail_sent": "Look for the password reset e-mail in your inbox.",
    "passwords_dont_match": "Passwords don't match",
    "previous_coms": "See previous comments",
    "public_link": "public link",
    "publish_in_group": "publish in the group",
    "pin_in_group": "pin in group",
    "unpin_in_group": "unpin",
    "quit_group": "Leave the group",
    "react": "React",
    "remove_bookmark": "Unbookmark message",
    "replies_one": "{{count}} reply",
    "replies_other": "{{count}} replies",
    "reply": "reply",
    "reset_api_key": "Reset the API key (you will be disconnected)",
    "reset_invitation_link": "Reset invitation link",
    "reset_password_title": "Reset your password",
    "save_changes": "Save changes",
    "search_in_group": "search in this group",
    "search_without_result": "Your search did not match any message.",
    "settings": "Settings",
    "settings_updated": "Your settings were updated",
    "share_message": "share the message",
    "signup": "Sign up",
    "submit": "Submit",
    "text_placeholder": "Write your message here",
    "the_message_from": "the message from",
    "title_placeholder": "Title of your message (optional)",
    "to": "to",
    "upload_audio": "Add an audio file.",
    "upload_image": "Add photos",
    "upload_music": "Add music",
    "upload_pdf": "Add PDF",
    "upload_video": "Add a video",
    "User not found": "User not found",
    "users": "users",
    "video_not_ready": "Video is not ready yet.",
    "weekly": "Weekly",
    "you_have_no_bookmarks": "You have no bookmarks"
}
